// extracted by mini-css-extract-plugin
export default {"paper":"TextCase_paper__UXEqh","row":"TextCase_row__4S55o"};